const regionalsArray = ['tamil', 'telugu', 'hindi', 'kannada', 'bengali'];

export default regionalsArray;

export const regionalsLangObject = {
  tamil: {
    title: 'Tamil',
    native: 'தமிழ்',
    staticPrimePrice: '₹4799',
    staticCurrentPrice: '₹3999',
    oneTimePricingLink: '/rgnl-tamil-nrc-193252a70f6',
    packages: [
      {
        id: 'tamil-animation-courses',
        title: 'Animated தமிழ்',
        groupName: 'animation',
        groupTitle: 'Animated',
        img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/IntroductionIconWhite.svg',
        pricingLink: '/tamil-animation-pricing',
        offerPricingLink: '/tamil-animation-sale',
        oneTimePricingLink: '/rgnl-tamil-anim-nrc-1933f54b282',
        offerPrice: '₹999',
        oldPrice: '₹1999',
        courseCount: '8',
        packageWorth: '₹5000',
        pathID: 'tamil-animation-membership',
        snackbarType: 'regionals-tamil-animation',
      },
      {
        id: 'tamil-expert-courses',
        title: 'Expert தமிழ்',
        groupName: 'professional',
        groupTitle: 'Expert',
        img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/IntroductionIconWhite.svg',
        pricingLink: '/tamil-expert-pricing',
        offerPricingLink: '/tamil-expert-sale',
        oneTimePricingLink: '/rgnl-tamil-exp-nrc-1933f54b282',
        offerPrice: '₹1999',
        oldPrice: '₹2999',
        courseCount: '20',
        packageWorth: '₹10000',
        pathID: 'tamil-expert-membership',
        snackbarType: 'regionals-tamil-expert',
      },
    ],
  },
  telugu: {
    title: 'Telugu',
    native: 'తెలుగు',
    staticPrimePrice: '₹999',
    staticOldPrice: '₹2999',
    oneTimePricingLink: '/rgnl-telugu-nrc-193252a70f6',
    packages: [
      {
        id: 'telugu-animation-courses',
        title: 'Animated తెలుగు',
        groupName: 'animation',
        groupTitle: 'Animated',
        img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/IntroductionIconWhite.svg',
        pricingLink: '/telugu-animation-pricing',
        offerPricingLink: '/telugu-animation-sale',
        oneTimePricingLink: '/rgnl-telugu-anim-nrc-1933f54b282',
        offerPrice: '₹1999',
        courseCount: '7',
        packageWorth: '₹4000',
        pathID: 'telugu-animation-membership',
      },
    ],
  },
  hindi: {
    title: 'Hindi',
    native: 'हिन्दी',
    staticPrimePrice: '₹999',
    staticOldPrice: '₹2999',
    oneTimePricingLink: '/rgnl-hindi-nrc-193252a70f6',
    packages: [
      {
        id: 'hindi-animation-courses',
        title: 'Animated हिन्दी',
        groupName: 'animation',
        groupTitle: 'Animated',
        img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/IntroductionIconWhite.svg',
        pricingLink: '/hindi-animation-pricing',
        offerPricingLink: '/hindi-animation-sale',
        oneTimePricingLink: '/rgnl-hindi-anim-nrc-1933f54b282',
        offerPrice: '₹1999',
        courseCount: '7',
        packageWorth: '₹5000',
        pathID: 'hindi-animation-membership',
      },
    ],
  },
  kannada: {
    title: 'Kannada',
    native: 'ಕನ್ನಡ',
    staticPrimePrice: '₹999',
    staticOldPrice: '₹1999',
    oneTimePricingLink: '/rgnl-kannada-nrc-193252a70f6',
    packages: [
      {
        id: 'kannada-animation-courses',
        title: 'Animated ಕನ್ನಡ',
        groupName: 'animation',
        groupTitle: 'Animated',
        img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/IntroductionIconWhite.svg',
        pricingLink: '/kannada-animation-pricing',
        offerPricingLink: '/kannada-animation-sale',
        oneTimePricingLink: '/rgnl-kannada-anim-nrc-1933f54b282',
        offerPrice: '₹1499',
        courseCount: '4',
        packageWorth: '₹2000',
        pathID: 'kannada-animation-membership',
      },
    ],
  },
  bengali: {
    title: 'Bengali',
    native: 'বাংলা',
    staticPrimePrice: '₹999',
    staticOldPrice: '₹1499',
    oneTimePricingLink: '/rgnl-bengali-nrc-193252a70f6',
    packages: [
      {
        id: 'bengali-animation-courses',
        title: 'Animated বাংলা',
        groupName: 'animation',
        groupTitle: 'Animated',
        img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/IntroductionIconWhite.svg',
        pricingLink: '/bengali-animation-pricing',
        offerPricingLink: '/bengali-animation-sale',
        oneTimePricingLink: '/rgnl-bengali-anim-nrc-1933f54b282',
        offerPrice: '₹999',
        courseCount: '3',
        packageWorth: '₹1000',
        pathID: 'bengali-animation-membership',
      },
    ],
  },
};
